import classNames from 'classnames';
import React from 'react';
import LottiePlayer from '@/components/elements/lottie-player';

function SliderContent({ animation, isActiveItem }) {
	return (
		<div className={classNames(isActiveItem ? 'block' : 'hidden')}>
			<LottiePlayer
				animation={animation}
				goTo={isActiveItem ? 0 : undefined}
				play={!!isActiveItem}
				rendererSettings={{ preserveAspectRatio: 'xMidYMid slice' }}
			/>
		</div>
	);
}

export default SliderContent;
